import { useContext } from 'react';
import { Context, ContextValue } from 'components/TwilioConversationProvider/';

const useTwilioConversation = () => useContext<ContextValue>(Context);

export default useTwilioConversation;
